import React from 'react';
import { Alert, Space } from 'antd';
import type { GroupValidationIssue } from './groupValidation';

type Props = {
  issues: GroupValidationIssue[];
};

export function GroupValidationAlerts({ issues }: Props) {
  if (!issues.length) return null;
  return (
    <Space direction="vertical" style={{ width: '100%', marginBottom: 12 }}>
      {issues.map((issue) => (
        <Alert
          key={`${issue.code}-${issue.groupUid}`}
          type="error"
          showIcon
          message={issue.message}
        />
      ))}
    </Space>
  );
}
